import React, { Component } from 'react'
import styled from 'styled-components'
import { getTheme, noSelect } from 'helpers'

import svgLeft from 'assets/svg/icon-left.svg'

export default class extends Component {
  render () {
    const { onBack, backTitle, title } = this.props
    return (
      <Container>
        <BtnBack onClick={onBack}>
          <IconLeft src={svgLeft} />
          <BackTitle>{backTitle}</BackTitle>
        </BtnBack>
        <span>{title}</span>
      </Container>
    )
  }
}

const Container = styled.section`
  height: 44px;
  line-height: 44px;
  background-color: ${getTheme`colorBorder`};
  position: relative;
  text-align: center;
  font-size: 16px;
  @media(min-width: 768px) { display: none; }
`
const BtnBack = styled.div`
  padding: 0px 10px;
  height: 44px;
  line-height: 44px;
  display: inline-block;
  vertical-align: top;
  text-align: center;
  position: absolute;
  top: 0px;
  left: 0px;
  ${noSelect}
`
const IconLeft = styled.img`
  width: 12px;
  height: 21px;
  vertical-align: middle;
`
const BackTitle = styled.div`
  display: inline-block;
  vertical-align: top;
  margin-left: 10px;
  color: ${getTheme`colorTiffanyDark`};
`



// WEBPACK FOOTER //
// ./src/components/NavBar.js